import(/* webpackMode: "eager" */ "/workspace/app/(marketing)/m/layout.tsx");
